import * as React from 'react';

import {Button} from 'shells/button/button';
import {Date} from 'shells/entity/entity-display-values/date';

import {appHistory} from '../../../../history';

import styles from './cell.module.css';

type Props = {
    name: string;
    value: {
        value: string | null | undefined;
        activityId: string | null | undefined;
        activityType: string | null | undefined;
    };
};

export function CellLastLoggedActivity(props: Props) {
    if (!props.value || !props.value.value) {
        return null;
    }

    const handleClick = (e: React.SyntheticEvent<any>) => {
        e.stopPropagation();
        if (!props.value.activityId) {
            return;
        }

        appHistory.replace({
            ...appHistory.location,
            hash: `/${props.value.activityId}-activities`,
            state: {modal: true},
        });
    };

    let cellContent = null;
    if (
        props.name === 'lastLoggedActivity_Time' &&
        props.value.activityType &&
        props.value.activityId
    ) {
        cellContent = (
            <Button variant='text-primary' onClick={handleClick} noPadding={true}>
                {/* @ts-expect-error */}
                <Date value={props.value.value} />- {props.value.activityType}
            </Button>
        );
    } else if (props.value.activityId) {
        cellContent = (
            <Button variant='text-primary' onClick={handleClick} noPadding={true}>
                {/* @ts-expect-error */}
                <Date value={props.value.value} />
            </Button>
        );
    } else if (props.name === 'lastLoggedActivity_Time' && props.value.activityType) {
        cellContent = (
            <>
                {/* @ts-expect-error */}
                <Date value={props.value.value} /> - {props.value.activityType}
            </>
        );
    } else {
        // @ts-expect-error
        cellContent = <Date value={props.value.value} />;
    }

    return <div className={styles['cell-content']}>{cellContent}</div>;
}
